import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BodyAnalysisForm from './pages/BodyAnalysisForm';
import CounsellingForm from './pages/CounsellingForm';
import InstagramPosts from './pages/InstagramPosts';
// import PlansPage from './pages/PlansPage'; // HIDDEN: Plans page disabled
import AccountPage from './pages/AccountPage';
import ResultsPage from './pages/ResultsPage';
import ResourcesPage from './pages/ResourcesPage';
// import InteractiveToolsPage from './pages/InteractiveToolsPage'; // HIDDEN: Interactive tools disabled
import ProgramsPage from './pages/ProgramsPage';
import FormsPage from './pages/FormsPage';
import BodyAnalysisReportPage from './pages/BodyAnalysisReportPage';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsOfService from './pages/legal/TermsOfService';
import Disclaimer from './pages/legal/Disclaimer';
import RefundPolicy from './pages/legal/RefundPolicy';
import CookiePolicy from './pages/legal/CookiePolicy';
import AffiliateDisclosure from './pages/legal/AffiliateDisclosure';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-[#FFFDF8]">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/body-analysis" element={<BodyAnalysisForm />} />
          <Route path="/body-analysis-report" element={<BodyAnalysisReportPage />} />
          <Route path="/counselling" element={<CounsellingForm />} />
          {/* <Route path="/plans" element={<PlansPage />} /> HIDDEN: Plans page disabled */}
          <Route path="/account" element={<AccountPage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          {/* <Route path="/interactive-tools" element={<InteractiveToolsPage />} /> HIDDEN: Interactive tools disabled */}
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/forms" element={<FormsPage />} />
          <Route path="/instagram" element={<InstagramPosts />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/affiliate-disclosure" element={<AffiliateDisclosure />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;